import {beforeWrite, ModifierArguments} from "@popperjs/core";
import {Options} from "@popperjs/core/lib/modifiers/computeStyles";

export const stickToBottomTooltipModifier = {
    name: "stickToBottom",
    enabled: true,
    phase: beforeWrite,
    fn: function(data: ModifierArguments<Options>) {
        const popperWidth = data.state.rects.popper.width;
        const popperHeight = data.state.rects.popper.height;
        const {styles, elements} = data.state;

        data.options.adaptive = false;

        data.state.strategy = "fixed";
        data.state.placement = "bottom";

        styles.popper = {
            top: (window.innerHeight - popperHeight - 10) + "px",
            left: (document.documentElement.clientWidth - popperWidth) / 2 + 'px'
        };

        styles.arrow = {
            bottom: '-7px',
            left: (popperWidth - elements.arrow.clientWidth) / 2 + 'px',
            top: 'auto'
        };
    }
};

export const offsetTooltipModifier = {
    name: 'offset',
    options: {
        offset: [10, 17]
    },
};

export const flipTooltipModifier = {
    name: "flip",
    options: {
        padding: 5
    }
};

export const preventOverflowTooltipModifier = {
    name: "preventOverflow",
    options: {
        padding: 5
    }
};
